<script>
import Topbar from '@components/topbar'
import AppMenu from '@components/app-menu'
import Footer from '@components/footer'
import agronomo from '@/src/services/agronomo'

export default {
  components: { Topbar, AppMenu, Footer },
  data() {
		return {
			isMenuCondensed: false,
			isMobileMenuOpened: false,
			user: this.$store ? this.$store.state.auth.currentUser : {} || {},
			layout: this.$store ? this.$store.state.layout.layoutType : null || null,
			theme: this.$store
				? this.$store.state.layout.leftSidebarTheme
				: null || null,
			type: this.$store
				? this.$store.state.layout.leftSidebarType
				: null || null,
			width: this.$store ? this.$store.state.layout.layoutWidth : null || null,
		}
	},
  created: () => {
    document.body.classList.remove('authentication-bg')
    document.body.classList.remove('authentication-bg-pattern')
    document.body.setAttribute('data-layout', 'topnav')
    document.body.classList.remove('right-bar-enabled')
    document.body.classList.remove('left-side-menu-condensed')
    document.body.classList.remove('boxed-layout')
  },
  mounted() {
    this.checkIfTokenExpired()
  },
  methods: {
    toggleMenu() {
      this.showMobileMenu = !this.showMobileMenu
      this.$forceUpdate();
    },
    toggleRightSidebar() {
      document.body.classList.toggle('right-bar-enabled')
    },
    checkIfTokenExpired() {
      
      const token = this.$store.state.auth.currentUser.token
      agronomo
        .listar(token)
        .then((resposta) => {
          this.isLoading = false
        })
        .catch((error) => {
          if (error.response.data) {
            if (error.response.data.message === 'Token expirou') {
              this.$bvModal.show('modal-session')
            }
          }
          this.isLoading = false
        })
    },
  },
}
</script>

<template>
  <div>
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->
    <Topbar :user="user" :is-menu-opened="showMobileMenu" />
    <div class="topnav shadow-sm">
      <div class="container-fluid">
        <nav class="navbar navbar-light navbar-expand-lg topbar-nav">
          <b-collapse
            id="topnav-menu-content"
            v-model="showMobileMenu"
            class="navbar-collapse"
          >
            <AppMenu mode="horizontal" />
          </b-collapse>
        </nav>
      </div>
    </div>
    <div class="content-page">
      <div class="content">
        <div class="container-fluid">
          <slot />
        </div>
      </div>
    </div>
    <b-modal :no-close-on-backdrop="true" :hide-header="true" id="modal-session" title="Ops" ok-only
      title-class="font-18">
      <p>Sua sessão expirou! é necessário realizar um novo login, por favor click no botão OK.</p>
      <template v-slot:modal-footer>
        <b-button variant="danger" @click="$router.push({ name: 'logout' })">OK</b-button>
      </template>
    </b-modal>
  </div>
</template>
